import React from 'react'
import PropTypes from 'prop-types'
import Error from './form-input-error'
import { injectIntl } from 'react-intl'

import Label from '../label'

class Textarea extends React.Component {
    static WAIT_IN_MS = 1000;

    static propTypes = {
        label: PropTypes.string,
        className: PropTypes.string,
        value: PropTypes.string,
        errorStr: PropTypes.string,
        disabled: PropTypes.bool,
        onChange: PropTypes.func
    }

    static defaultProps = {
        errorStr: 'app.error'
    }

    state = {
        value: this.props.value || '',
        error: false
    }

    onChangeTimeout = false;

    getInputHeight() {
        return this.input.scrollHeight !== 10 ? this.input.scrollHeight : 100
    }

    handleChange({target={}}) {
        let { value } = target
        this.setState({value})

        this.onChangeTimeout && clearTimeout(this.onChangeTimeout);
        this.onChangeTimeout = setTimeout( () => {
            this.input.style.cssText = 'height:auto;';
            this.input.style.cssText = 'height:' + this.getInputHeight() + 'px';
            this.onChange(value)
        }, Textarea.WAIT_IN_MS)
    }

    onChange(value) {
        let { onChange = false } = this.props
        if(!onChange) {
            return
        }
        let promise = onChange(value) || Promise.resolve(value)
        !promise._state && this.setState({loading: true})
        promise.then(e => setTimeout(() => {
            this.setState({loading: false, error: false})
        }, 10))
        .catch( e => this.setState({loading: false, error: true}));
    }

    componentWillUnmount() {
        this.onChangeTimeout && clearTimeout(this.onChangeTimeout);
    }

    UNSAFE_componentWillReceiveProps(nextProps, nextState) {
        this.setState({value: nextProps.value})
    }

    UNSAFE_componentWillUpdate(nextProps, nextState) {
        return nextProps.value && nextProps.value !== this.state.value
    }

    componentDidMount() {
        this.input.style.cssText = 'height:auto;';
        this.input.style.cssText = 'height:' + this.getInputHeight() + 'px';
    }

    render() {
        let { intl, label=false, className=false, errorStr='app.error', disabled } = this.props;
        let { error, value, loading } = this.state;

        return (<div className={"form form-text" + (className ? ' ' + className : '')}>
            <Label>{label}</Label>

            <div className={'form-data' + (error?' error':'')}>
                {disabled && <div ref={ input => this.input = input} className="disabled">{value}</div>}
                {!disabled && <textarea
                    ref={ input => this.input = input}
                    placeholder={label ? intl.formatMessage({id: label + '.placeholder'}) : ''}
                    onChange={this.handleChange.bind(this)}
                    onBlur={this.handleChange.bind(this)}
                    value={value}
                    disabled={loading} />}
                <Error visible={error} message={errorStr} />
            </div>
        </div>);
    }
}

export default injectIntl(Textarea)

